export enum BeeStatus {
  NotFound = 'NotFound', // not registered
  Offline = 'Offline', // registered but no activity within 12hrs
  Online = 'Online', // registered with activity within 12hrs
}

export enum Project {
  OptimisedRetrofit = 'Optimised Retrofit',
  Penderi = 'Penderi',
  EasternHigh = 'Eastern High',
  ParcEirin = 'Parc Eirin',
  CountyFlats = 'County Flats',
  Ladyhill = 'Ladyhill',
  Gwynfaen = 'Gwynfaen',
  OSBPilots = 'OSB Pilots',
  AddisonHouse = 'Addison House',
  CourtPlace = 'Court Place',
  Brookfield = 'Brookfield',
  SeroTesting = 'Sero Testing',
  MHG = 'MHG',
  SovereignSHDF = 'Sovereign SHDF',
  SpringGardens = 'Spring Gardens',
}

export enum BeeModeDBEntries {
  M = 'Monitor Only',
  C = 'Control And Monitor',
  MES = 'Monitor And Energy Services',
  CES = 'Control And Energy Services',
}
